import React from 'react';
import { entries, reduce } from 'lodash';

import { useProductState } from '../../store';

import { IProductInfo } from '@/models';

import Characteristic from './Characteristic';

const characteristicsMap = {
  Fit: [
    { label: 'Regular', value: 'RG' },
    { label: 'Comfort', value: 'CF' },
    { label: 'Slim', value: 'SL' },
    { label: 'Aero', value: 'AE' }
  ],
  Temperature: [
    { label: 'Very Low', value: '02' },
    { label: 'Low', value: '03' },
    { label: 'Mid Low', value: '04' },
    { label: 'Mid', value: '05' },
    { label: 'Mid High', value: '06' },
    { label: 'High', value: '07' },
    { label: 'Very High', value: '08' }
  ],
  SocksHeight: [
    { label: 'Low', value: '01' },
    { label: 'Mid', value: '02' },
    { label: 'High', value: '03' }
  ],
  SocksCushion: [
    { label: 'Light', value: '01' },
    { label: 'Mid', value: '02' },
    { label: 'Extra', value: '03' }
  ],
  SocksThickness: [
    { label: 'Ultra Thin', value: '01' },
    { label: 'Thin', value: '02' },
    { label: 'Mid', value: '03' }
  ],
  InsulationLevel: [
    { label: 'Low', value: '05' },
    { label: 'Mid Low', value: '06' },
    { label: 'Mid', value: '01' },
    { label: 'Mid High', value: '02' },
    { label: 'High', value: '03' },
    { label: 'Very High', value: '04' }
  ],
  SocksCompression: [
    { label: 'Light', value: '02' },
    { label: 'Mid', value: '03' },
    { label: 'High', value: '04' }
  ],
  ActivityIntensity: [
    { label: 'Low', value: '01' },
    { label: 'Mid', value: '02' },
    { label: 'High', value: '03' }
  ]
};

const Characteristics = () => {
  const { product } = useProductState();

  const components = reduce(
    entries(characteristicsMap),
    (characteristics, [key, options]) => {
      const value = product.productInfo[key as keyof IProductInfo];

      if (
        typeof value === 'string' &&
        options.some(({ value: _value }) => _value === value)
      ) {
        characteristics.push(
          <Characteristic
            key={key}
            name={key}
            value={value}
            options={options}
          />
        );
      }

      return characteristics;
    },
    [] as JSX.Element[]
  );

  return <div className="space-y-6 pt-6">{components}</div>;
};

export default Characteristics;
